module.exports = __webpack_public_path__ + "static/choppedLogo-54a2661a3553710f297633be54155ce9.png";